import * as React from 'react';
import {  FormCheckbox} from '../validation/Form-Components';
import { Field } from '@progress/kendo-react-form';

const CusFormCheckbox = (props) => {

    const { value, onChange, ...others } = props;
 
    const handleCheckedChange = (e) =>{
        props.onCheckedChange(e.value,props);
    }

    return(
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{paddingTop:'10px'}}>
        <div style={{width:'8%',float:'left'}}>
            <Field id={props.id} name={props.id} component={FormCheckbox} disabled={others.disabled}
                checked={value} onChange={handleCheckedChange}>
            </Field>
         </div>
         <div style={{width:'92%',float:'left'}}  className={'k-form-field'}>
             <label className={'k-checkbox-label'} >{props.lblname}</label>
         </div>
        </div>
    )
}

export default CusFormCheckbox;